// JAWS vs VoiceOver (see doc/jaws-voiceover-accessibility-reference.md §5):
// - Uses global #aria_polite / #aria_assertive for async/errors only (not step progress).
// - Step progress is an sr-only h2 referenced from the step h1 aria-describedby.
// - On SPA step change, focus moves to the step h1 so AT reads title then progress.

import React, { createContext, useCallback, useContext, useEffect } from 'react'
import {
  announceAria,
  resetAriaAnnouncer,
  focusStepHeading,
} from '../../util/ariaAnnouncer'

const AnnouncerContext = createContext(() => {})

export const useAnnouncer = () => useContext(AnnouncerContext)

export const focusStepOnChange = () => {
  requestAnimationFrame(focusStepHeading)
}

export { focusStepHeading }

export const AnnouncerProvider = ({ children }) => {
  const announce = useCallback((message, options = {}) => {
    announceAria(message, options)
  }, [])

  useEffect(() => resetAriaAnnouncer, [])

  return (
    <AnnouncerContext.Provider value={announce}>
      {children}
    </AnnouncerContext.Provider>
  )
}

export default AnnouncerProvider
